import React from 'react';
import styled from 'styled-components';
import {
    FlowStyled,
    RunCodeStyled
} from '../../../../style/components/common.styled';
import { EuiButton, EuiCodeBlock, EuiCopy, EuiSpacer } from '@elastic/eui';
import { getAgentInstallCommand } from '../../../../constants/agent.constants';

const Styles = styled.div`
  text-align: center;

  h2 {
    font-size: 32px;
  }

  .install {
    div {
      font-size: 20px;
    }
  }
`;

const ServerNoDataRecieved = ({ server }) => {
    const installCommand = getAgentInstallCommand(server._id);

    return (
        <Styles>
            <h2>Awaiting for data</h2>

            <FlowStyled>
                <h3>How does it work?</h3>
                <ul>
                    <li>Create server name</li>
                    <li>Copy and run code below to Install <a
                        href="https://github.com/syagent/agent-2"
                        rel="noreferrer"
                        target="_blank">the Agent</a> (The code is
                        OPEN, you can check what
                        is monitored)
                    </li>
                    <li>Wait for data</li>
                    <li>Profit..</li>
                </ul>
            </FlowStyled>

            <div className="install">
                <RunCodeStyled>
                    Run following code as root in your server to install the
                    agent
                    <EuiSpacer size="l"/>
                    <EuiCodeBlock language="jsx" fontSize="m"
                                  paddingSize="m">
                        { installCommand }
                    </EuiCodeBlock>
                    <EuiSpacer size="l"/>

                    <EuiCopy
                        textToCopy={ installCommand }>
                        { copy => (
                            <EuiButton onClick={ copy }
                                       iconType={ 'copyClipboard' }
                                       color={ 'success' }>Click
                                to
                                copy</EuiButton>
                        ) }
                    </EuiCopy>

                </RunCodeStyled>
            </div>
        </Styles>
    );
};

export default ServerNoDataRecieved;
